import { CLOSE_BUY_NOW_MODAL } from 'dealer-reducers'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import View from 'src/components/atoms/View'
import CloseXSvg from 'src/components/other/svg/CloseXSvg'
import BuyNowModalContent from './BuyNowModalContent'
import { RootReducer } from 'src/redux/rootReducer'
import ThankYouBuyNowModalContent from './ThankYouBuyNowModalContent'

const BuyNowModal = (): JSX.Element => {
  const dispatch = useDispatch()
  const { thankYouVariant, offerId, buyNowPrice } = useSelector((state: RootReducer) => state.tableToolsReducer)
  const showBuyNowModal = useSelector((state: RootReducer) => state.tableToolsReducer.showBuyNowModal)

  useEffect(() => {
    return () => {
      dispatch(CLOSE_BUY_NOW_MODAL())
    }
  }, [dispatch])

  return (
    <View
      style={{ transform: showBuyNowModal ? 'translateY(0)' : 'translateY(-110%)', transition: 'transform 0.5s' }}
      className="absolute left-0 top-0 bg-groupBlue w-full z-40 rounded-4 h-full overflow-hidden p-4">
      <CloseXSvg
        className="flex justify-center items-center border border-white w-8 h-8 rounded-4 text-white absolute top-3 right-3 cursor-pointer"
        svgStyles="w-3 h-3"
        onClick={() => {
          dispatch(CLOSE_BUY_NOW_MODAL())
        }}
      />
      {thankYouVariant ? (
        <ThankYouBuyNowModalContent />
      ) : (
        <BuyNowModalContent offerId={offerId} buyNowPrice={buyNowPrice} />
      )}
    </View>
  )
}

export default BuyNowModal
